import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'lex-bar-chart-skeleton-loader',
    templateUrl: './bar-chart-skeleton-loader.component.html',
    styleUrl: './bar-chart-skeleton-loader.component.scss',
    standalone: false
})
export class BarChartSkeletonLoaderComponent implements OnInit {
  @Input() dataset: string[] = [];
  @Input() orientation: "vertical" | "horizontal" = "vertical";
  @Input() isStacked: boolean = false;
  @Input() barCount: number = 10; 
  @Input() barThickness: string = '15px';
  @Input() legendItemCount: number = 3;
  @Input() shouldShowIndependentAxisTickMarks: boolean = true;
  @Input() numDependentAxisTickMarks: number = 0;
  @Input() evenOddColorScheme: boolean = false;
  @Input() sortOrder: "ascending" | "descending" | "none" = "none";

  public dependentAxis: "x-axis" | "y-axis" = "y-axis";
  public legendCountArray: number[];
  public tickMarksCountArray: number[];

  private minInput = 1;
  private maxInput = 10;
  private defaultDataset: string[] = ["50%", "65%", "75%", "85%", "98%", "95%", "75%", "60%", "52%", "40%"];

  ngOnInit(): void {

    if (this.isWithinMinMaxValuesRange(this.dataset.length, this.minInput, this.maxInput) === false) {
      this.dataset = this.defaultDataset;
    }
    if (this.isWithinMinMaxValuesRange(this.barCount, this.minInput, this.dataset.length) === false) {
      this.barCount = this.dataset.length;
    }
    if (this.isWithinMinMaxValuesRange(this.legendItemCount, 0, this.maxInput) === false) {
      this.legendItemCount = this.dataset.length;
    }
    if (this.isWithinMinMaxValuesRange(this.numDependentAxisTickMarks, 0, this.maxInput) === false) {
      this.numDependentAxisTickMarks = this.dataset.length;
    }

    this.legendCountArray = Array(this.legendItemCount).fill(0).map((x,i)=>i);
    this.tickMarksCountArray = Array(this.numDependentAxisTickMarks).fill(0).map((x,i)=>i);
    
    if (this.orientation === "horizontal") {
      this.dependentAxis = "x-axis";
    }

    if (this.sortOrder === "ascending") {
      this.dataset.sort();    
    }
    else if (this.sortOrder === "descending") {
      this.dataset.sort((a, b) => (b < a ? -1 : 1));    

    }
  }

  private isWithinMinMaxValuesRange(inputValue: number, minInput: number, maxInput: number) : boolean {
    if (inputValue < minInput || inputValue > maxInput) {
      return false;
    }
    return true;
  }
}
